export const LANG_DROPLIST = 'LANG/DROPLIST'
export const LANG_CHANGE = 'LANG/CHANGE'

export const TOGGLE_MENU = 'TOGGLE/MENU'